__turbopack_context__.v({
  "cardsContainer": "PersonaCardsSection-module__8MZBoa__cardsContainer",
  "content": "PersonaCardsSection-module__8MZBoa__content",
  "overlayGradient": "PersonaCardsSection-module__8MZBoa__overlayGradient",
  "personaCard": "PersonaCardsSection-module__8MZBoa__personaCard",
  "root": "PersonaCardsSection-module__8MZBoa__root" + " " + __turbopack_context__.i(92740)["sectionPadding"],
  "smImgOfLeft": "PersonaCardsSection-module__8MZBoa__smImgOfLeft",
  "textContent": "PersonaCardsSection-module__8MZBoa__textContent",
});
